module.exports = __webpack_public_path__ + "img/b4-2.2897da7.png";